module.exports = __webpack_public_path__ + "static/delivery-service-251a3312393cb73c545d13c24263cc3f.png";